import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

import $ from "jquery";

import StsLogs from "./Reports";
import StsSubstitutions from "./CustomData";
import StsSettings from "./ParibhasaSettings";

class StsLeftPanel extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var projectSettingsPathExist = false;
      var projectSettingsTabsPatterns = ["/api-keys"];
      for (var i = 0; i < projectSettingsTabsPatterns.length; i++) {
        if (currentPath.includes(projectSettingsTabsPatterns[i]) == true) {
          projectSettingsPathExist = true;
          break;
        }
      }
      var path = window.origin + "/platform/cloud-sts/";
      var path1 = window.origin + "/platform/cloud-sts";
      if (
        currentPath == path ||
        currentPath == path1 ||
        projectSettingsPathExist
      ) {
        $("#left-panel-menu-pbsSettings").addClass("activemenu");
      } else if (currentPath.includes("/reports")) {
        $("#left-panel-menu-cloud-sts-reports").addClass("activemenu");
      } else if (currentPath.includes("/custom-data")) {
        $("#left-panel-menu-cloud-sts-custom-data").addClass("activemenu");
      }
      $(
        "#left-panel-menu-pbsSettings,#left-panel-menu-cloud-sts-reports,#left-panel-menu-cloud-sts-custom-data"
      ).on("click", function () {
        $(
          "#left-panel-menu-pbsSettings,#left-panel-menu-cloud-sts-reports,#left-panel-menu-cloud-sts-custom-data"
        ).removeClass("activemenu");
        localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
        $(this).addClass("activemenu");
      });
    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div>
          <link
            rel="stylesheet"
            href="./plugins/font-awesome/css/font-awesome.min.css"
          />
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link rel="stylesheet" href="./assets/css/adminlte.css" />
          <link rel="stylesheet" href="./assets/css/styles.css" />
          <link rel="stylesheet" href="./assets/css/custom-style.css" />
          <link rel="stylesheet" href="./plugins/iCheck/all.css" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link href="assets/css/scrollbar.css" rel="stylesheet" />
          <div className="content-wrapper">
            <div
              className="left-menu"
              style={{ marginTop: "0px", position: "absolute" }}
            >
              <ul id="floatMenu">
                <Link to="/cloud-sts">
                  <li id="left-panel-menu-pbsSettings" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Paribhasha Settings</span>
                  </li>
                </Link>
                <Link to="/cloud-sts/custom-data">
                  <li
                    id="left-panel-menu-cloud-sts-custom-data"
                    className="tabs"
                  >
                    <i className="fa flaticon-ui" />
                    <span>Custom Data</span>
                  </li>
                </Link>

                <Link to="/cloud-sts/reports">
                  <li id="left-panel-menu-cloud-sts-reports" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Report</span>
                  </li>
                </Link>
              </ul>
            </div>
          </div>
          <Switch>
            <Route path="/cloud-sts/reports" component={StsLogs}></Route>
            <Route
              path="/cloud-sts/custom-data"
              component={StsSubstitutions}
            ></Route>
            <Route path="/cloud-sts" component={StsSettings}></Route>
          </Switch>
        </div>
      </Router>
    );
  }
}
export default StsLeftPanel;



// WEBPACK FOOTER //
// ./src/stsUi/StsLeftPanel.js